import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, GraduationCap } from "lucide-react";
import { Button } from "@/components/ui/button";

const ExamProjectBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const hasSeenBanner = localStorage.getItem("exam-project-banner-seen");
    if (!hasSeenBanner) {
      const timer = setTimeout(() => setShowBanner(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const closeBanner = () => {
    localStorage.setItem("exam-project-banner-seen", "true");
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="fixed top-20 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-lg px-2"
        >
          <div className="bg-primary/95 backdrop-blur-sm text-primary-foreground rounded-lg shadow-xl border border-primary-foreground/20 p-3 sm:p-4">
            <div className="flex items-start gap-2 sm:gap-3">
              <GraduationCap className="h-5 w-5 sm:h-6 sm:w-6 flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0 pr-1">
                <h3 className="font-semibold text-base sm:text-lg mb-1">Eksamensprojekt</h3>
                <p className="text-xs sm:text-sm text-primary-foreground/90">
                  Dette website er et fiktivt eksamensprojekt. Shoppen er ikke reel, og der kan ikke foretages rigtige køb.
                </p>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={closeBanner}
                className="flex-shrink-0 h-8 w-8 min-w-[32px] text-primary-foreground hover:bg-primary-foreground/20"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ExamProjectBanner;
